import Typography from '@mui/material/Typography';
import CardSection from '@shared/components/CardSection';
import type { VesselInfo as VesselInfoType } from '../types';

interface Props {
  vessel: VesselInfoType;
}

export default function VesselInfo({ vessel }: Props) {
  return (
    <CardSection>
      <Typography variant="subtitle2" color="text.secondary" gutterBottom>
        Vessel Information
      </Typography>
      <Typography variant="h6">{vessel.vesselName}</Typography>
      <dl className="mt-2 grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
        <dt className="text-[var(--color-text-secondary)]">IMO</dt>
        <dd>{vessel.imoNumber ?? '—'}</dd>
        <dt className="text-[var(--color-text-secondary)]">Vessel ID</dt>
        <dd>{vessel.vesselId}</dd>
        <dt className="text-[var(--color-text-secondary)]">Device ID</dt>
        <dd className="truncate">{vessel.deviceId}</dd>
      </dl>
    </CardSection>
  );
}
